import { useMemo } from 'react';

import { BoardCrop, BoardStatus } from 'features/Croptimizer/types';
import { d23loss } from 'features/Croptimizer/utils/calcHelperBoard';
import { unMaskInput } from 'utils/helpers';

interface Props {
  boardStatusValues: BoardStatus | null;
  boardCropValues: BoardCrop | null;
  getY1CurrentLoss: string;
  getY2CurrentLoss: string;
  getY3CurrentLoss: string;
  getY4CurrentLoss: string;
  getY5CurrentLoss: string;
}

const useYieldLoss = ({
  boardStatusValues,
  boardCropValues,
  getY1CurrentLoss,
  getY2CurrentLoss,
  getY3CurrentLoss,
  getY4CurrentLoss,
  getY5CurrentLoss,
}: Props) => {
  const getY1YieldLoss = useMemo(() => {
    if (boardStatusValues && boardCropValues) {
      const d23 = d23loss(
        Number(boardCropValues?.cropGroupYield),
        Number(getY1CurrentLoss),
        Number(boardStatusValues?.targetPh),
      );
      const d24 =
        d23 && Number(unMaskInput(boardCropValues?.currentYield)) * d23;
      const d25 = d24 && d24 * Number(unMaskInput(boardCropValues?.price));

      return Math.round(d25 ? d25 : 0);
    }
  }, [boardCropValues, boardStatusValues, getY1CurrentLoss]);

  const getY2YieldLoss = useMemo(() => {
    if (boardStatusValues && boardCropValues) {
      const d23 = d23loss(
        Number(boardCropValues?.cropGroupYield),
        Number(getY2CurrentLoss),
        Number(boardStatusValues?.targetPh),
      );
      const d24 =
        d23 && Number(unMaskInput(boardCropValues?.currentYield)) * d23;
      const d25 = d24 && d24 * Number(unMaskInput(boardCropValues?.price));

      return Math.round(d25 ? d25 : 0);
    }
  }, [boardCropValues, boardStatusValues, getY2CurrentLoss]);

  const getY3YieldLoss = useMemo(() => {
    if (boardStatusValues && boardCropValues) {
      const d23 = d23loss(
        Number(boardCropValues?.cropGroupYield),
        Number(getY3CurrentLoss),
        Number(boardStatusValues?.targetPh),
      );
      const d24 =
        d23 && Number(unMaskInput(boardCropValues?.currentYield)) * d23;
      const d25 = d24 && d24 * Number(unMaskInput(boardCropValues?.price));

      return Math.round(d25 ? d25 : 0);
    }
  }, [boardCropValues, boardStatusValues, getY3CurrentLoss]);

  const getY4YieldLoss = useMemo(() => {
    if (boardStatusValues && boardCropValues) {
      const d23 = d23loss(
        Number(boardCropValues?.cropGroupYield),
        Number(getY4CurrentLoss),
        Number(boardStatusValues?.targetPh),
      );
      const d24 =
        d23 && Number(unMaskInput(boardCropValues?.currentYield)) * d23;
      const d25 = d24 && d24 * Number(unMaskInput(boardCropValues?.price));

      return Math.round(d25 ? d25 : 0);
    }
  }, [boardCropValues, boardStatusValues, getY4CurrentLoss]);

  const getY5YieldLoss = useMemo(() => {
    if (boardStatusValues && boardCropValues) {
      const d23 = d23loss(
        Number(boardCropValues?.cropGroupYield),
        Number(getY5CurrentLoss),
        Number(boardStatusValues?.targetPh),
      );
      const d24 =
        d23 && Number(unMaskInput(boardCropValues?.currentYield)) * d23;
      const d25 = d24 && d24 * Number(unMaskInput(boardCropValues?.price));

      return Math.round(d25 ? d25 : 0);
    }
  }, [boardCropValues, boardStatusValues, getY5CurrentLoss]);

  const getTotalYieldLoss = useMemo(() => {
    if (
      getY1YieldLoss &&
      getY2YieldLoss &&
      getY3YieldLoss &&
      getY4YieldLoss &&
      getY5YieldLoss
    ) {
      return (
        getY1YieldLoss +
        getY2YieldLoss +
        getY3YieldLoss +
        getY4YieldLoss +
        getY5YieldLoss
      );
    }

    return;
  }, [
    getY1YieldLoss,
    getY2YieldLoss,
    getY3YieldLoss,
    getY4YieldLoss,
    getY5YieldLoss,
  ]);

  return {
    getY1YieldLoss,
    getY2YieldLoss,
    getY3YieldLoss,
    getY4YieldLoss,
    getY5YieldLoss,
    getTotalYieldLoss,
  };
};

export default useYieldLoss;
